import TextArea from 'antd/lib/input/TextArea'
import {SubmitButton} from 'components/form/FormActionBar'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {bindQueryParam} from 'views/AppLocals/functions/routerHelper'
import {doc_addKeyword_Api} from '../../apis'
import ApiInfoForm from '../../components/form/ApiInfoForm'
import FieldDecorator from '../../components/form/FieldDecorator'
import {createValue} from '../../components/form/utils'
import LookupField from '../../components/LookupField'
import Translate from "../../modules/local/Translate";
import {renderIf} from "../Shared";
import {Avatar} from "antd";
import _ from "lodash";

export const KeywordCreation = ({document_id, keyword, onClose}) => {
  const t = useTranslate()
  return (
    <ApiInfoForm
      disableNotify={false}
      onSuccess={() => {
        onClose()
      }}
      initialValues={{
        keyword: keyword,
        description: '',
        post_id: null,
      }}
      apiInfo={doc_addKeyword_Api}
      query={bindQueryParam({id: document_id})}>
      {({
          isSubmitting,
          dirty,
          isValid,
          values = {},
          validate,
          handleChange,
          handleSubmit,
          ...props
        }) => (
        <div className="flex flex-col">
          <FieldDecorator label="description">
            <TextArea
              name={'description'}
              rows={3}
              onChange={(e) => {
                handleChange(createValue('description', e.target.value))
              }}
            />
          </FieldDecorator>
          <FieldDecorator label={t('document')}>
            <LookupField
              createIfNotExists={false}
              defaultValue={values.document_id}
              apiPath={`/docs/lookup/document`}
              name={'document_id'}
              handleChange={(e) => {
                handleChange(createValue('document_name', e.target.value))
                handleChange(createValue('document_id', e.target.id))
              }}
              renderOption={(o, i) => {
                return (
                  <Translate key={i}>
                    {
                      t => (
                        <React.Fragment>
                          {renderIf(
                            o.avatar,
                            <Avatar
                              src={o.avatar}
                              size={25}
                              className="flex flex-center background-200"
                            />
                          )}
                          <div className="flex flex-col flex-1 gap-1">
                            <span className="font-bold text-sm text-color-000 flex-1 leading-tight">{o.label}</span>
                            {(_.get(o, 'issued_org_name') || _.get(o, 'document_no')) && (
                              <div className="flex items-center gap-1 italic leading-snug">
                                <span className="font-medium text-2xs text-primary">{_.get(o, 'issued_org_name')}</span>
                                <span className="font-medium text-2xs text-color-200"><span className="text-color-400">
                    {` -  ${t('document no')} : `}</span>
                                  {_.get(o, 'document_no')}</span>
                              </div>
                            )}
                          </div>
                        </React.Fragment>
                      )
                    }
                  </Translate>
                )
              }}
            />
            <div className="font-medium py-3">{values.document_name}</div>
          </FieldDecorator>
          <FieldDecorator label="note">
            <TextArea
              name={'note'}
              rows={3}
              onChange={(e) => {
                handleChange(createValue('note', e.target.value))
              }}
            />
          </FieldDecorator>
          <div className="flex w-full justify-end float-right py-3">
            <SubmitButton dirtyRequired={false}/>
          </div>
        </div>
      )}
    </ApiInfoForm>
  )
}

export default KeywordCreation
